<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-06 09:00:19
 * @Descripttion:
-->
<template>
  <div class="foot">
 
  </div>
</template>

<script>
import { GetEmail } from "@/assets/server/api.js";
export default {
  data() {
    return {
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
      W: document.body.clientWidth + "px",
    };
  },
  created() {
    // this.$bus.$emit("goAuchor", "#one");
  },
  methods: {
    Push(index) {},
    async submitForm(formName) {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          console.log(formData);
          let data = await GetEmail(formData);
          this.$message({
            showClose: true,
            message: "Mailbox subscription succeeded",
            type: "success",
          });
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }

      // this.$refs[formName].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>

<style lang="less" scoped>
.foot {
  width: 100%;
  height: 66px;
  background: #000;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.footer-W {
  width: 1560px;
  margin: 0 auto;
  background: #000;
  .footer {
    margin-top: 179px;
    .footerw {
      display: flex;
      justify-content: space-between;
      .footerleft {
        img {
          width: 168px;
          height: 30px;
        }
        .footercon {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 3px;
        }
      }
      .footerright {
        display: flex;
        .footerli {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          margin-right: 40px;
          cursor: pointer;
        }
      }
    }
    .footerb {
      display: flex;
      justify-content: space-between;
      margin-top: 25px;
      .footerbleft {
        img {
          width: 15px;
          height: 15px;
          margin-top: 4px;
          margin-right: 4px;
        }
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 17px;
        color: #ffffff;
        line-height: 26px;
      }
      .footerbright {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        word-spacing: 8px;
        span {
          margin-left: 41px;
        }
        img {
          width: 16px;
          height: 18px;
          margin-top: 6px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
